export default {
  /**
   * Sort Booleans
   */
  boolean: (a: boolean, b: boolean, desc: boolean = false) => {
    if (a === b) {
      return 0;
    }
    if (desc) {
      return a ? 1 : -1;
    }
    return a ? -1 : 1;
  },
  /**
   * Sort Date Strings
   */
  date: (a: string, b: string, desc: boolean = false) => {
    const dateA = new Date(a);
    const dateB = new Date(b);
    return desc ? dateB - dateA : dateA - dateB;
  },
  /**
   * Sort Numbers
   * @param {string} a
   * @param {string} b
   * @param {?boolean} desc
   */
  number: (a: string, b: string, desc: boolean = false) => (desc ? b - a : a - b),
  /**
   * Sort Strings
   */
  string: (a: string, b: string, desc: boolean = false) => {
    const stringA = (a || '').toLowerCase();
    const stringB = (b || '').toLowerCase();
    if (desc ? stringB < stringA : stringA < stringB) {
      return -1;
    }
    if (desc ? stringA < stringB : stringB < stringA) {
      return 1;
    }
    return 0;
  },
};
